// Single source of truth for resolving "which auditor am I" and "which slot on this job".
// Used by My Audits and Audit Execution so the rule can't drift between them.
//
// Tightened over the old per-screen logic:
//   • The auditors.user_id link is authoritative. The name fallback applies ONLY when the login has
//     no user_id-linked auditor record, and only when the name is UNAMBIGUOUS (one record) — so a
//     duplicate name can never silently grant access.
//   • Slot resolution prefers the stable auditor_id link. A name match is allowed ONLY for a slot that
//     has no auditor_id (legacy jobs assigned by name) — so a job id-assigned to someone else can never
//     be pulled in by a name collision.

export function resolveMyAuditor(auditors, profile, email) {
  const list = auditors || []
  // 1) Authoritative: the auditor record linked to this login by user_id.
  const linked = list.find(a => a.user_id && profile?.id && a.user_id === profile.id)
  if (linked) return linked
  // 2) Reliable bridge: case-insensitive email match (login email == personnel email).
  const mail = (email || '').trim().toLowerCase()
  if (mail) { const byEmail = list.find(a => (a.email || '').trim().toLowerCase() === mail); if (byEmail) return byEmail }
  // 3) Last resort for legacy records: unambiguous name match (can fail if name order differs).
  const byName = list.filter(a => a.name && profile?.name && a.name === profile.name)
  return byName.length === 1 ? byName[0] : null
}

export function slotForAuditor(job, myAuditor, profile) {
  if (!job) return null
  // Prefer the stable auditor_id link.
  if (myAuditor) {
    if (job.auditor_id === myAuditor.id) return 'auditor1'
    if (job.auditor2_id === myAuditor.id) return 'auditor2'
  }
  // Legacy jobs assigned by name only (no auditor_id on that slot): match the canonical name.
  const name = (myAuditor && myAuditor.name) || profile?.name
  if (name) {
    if (!job.auditor_id && job.auditor_name === name) return 'auditor1'
    if (!job.auditor2_id && job.auditor2_name === name) return 'auditor2'
  }
  return null
}
